import type { ConsentEngineConfig } from "@moznsystems/mozn-ui/consent";

const CONSENT_CATEGORY = {
	/**
	 * Always on, no consent asked: Keycloak session, Sentry error reporting
	 * (no cookies), and UI preferences such as the sidebar state.
	 */
	NECESSARY: "necessary",
	/** Focal fraud browser SDK: device fingerprint and browser signals. */
	FRAUD_PREVENTION: "fraud_prevention",
	/** Userpilot in-app guides and onboarding. */
	FUNCTIONAL: "functional",
	/** Microsoft Clarity and Hotjar session recordings and heatmaps. */
	ANALYTICS: "analytics",
} as const;

type ConsentCategoryId =
	(typeof CONSENT_CATEGORY)[keyof typeof CONSENT_CATEGORY];

const CONSENT_CONFIG: ConsentEngineConfig = {
	storageKey: "focal-fraud-cookie-consent",
	// Bump whenever a category is added, removed or repurposed, or a vendor
	// moves into a category whose description no longer covers it.
	revision: 1,
	// Re-ask every six months, the retention period the CNIL recommends.
	maxAgeDays: 180,
	categories: [
		{ id: CONSENT_CATEGORY.NECESSARY, required: true },
		{ id: CONSENT_CATEGORY.FRAUD_PREVENTION },
		{ id: CONSENT_CATEGORY.FUNCTIONAL },
		{ id: CONSENT_CATEGORY.ANALYTICS },
	],
};

export { CONSENT_CATEGORY, CONSENT_CONFIG };
export type { ConsentCategoryId };
